"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaScroller = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.MediaScroller = styled_components_1.default.div `
  display: grid;
  gap: 2px;
  overflow-x: auto;
  padding-bottom: ${(props) => props.paddingBottom};
  grid-auto-flow: column;
  grid-auto-columns: 360px;
  overscroll-behavior-inline: contain;
  scroll-snap-type: inline mandatory;
  scroll-padding-inline: 1rem;
  justify-content: center;

  > * {
    scroll-snap-align: start;
  }

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    border: 7px solid white;
    background-color: #b7bec6;
    margin: 50px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #58677a;
    border-top: 6px solid white;
    border-bottom: 6px solid white;
  }
`;
